import { render } from "./PhotoViewer.vue?vue&type=template&id=606dc22d&scoped=true"
import script from "./PhotoViewer.vue?vue&type=script&lang=js"
export * from "./PhotoViewer.vue?vue&type=script&lang=js"

import "./photo-viewer.scss?vue&type=style&index=0&id=606dc22d&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-606dc22d"]])

export default __exports__